/**
 * @desc claimStockAdjustment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.StockAdjustmentCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustment/claim`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
